var map = {
	"./Rounds-01.png": 101,
	"./Rounds-02.png": 102,
	"./Rounds-03.png": 103,
	"./Rounds-04.png": 104,
	"./Rounds-05.png": 105,
	"./Rounds-06.png": 106,
	"./Rounds-07.png": 107,
	"./Rounds-08.png": 108,
	"./Rounds-09.png": 109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41;